<template>
    <client-page>
        <mypage-layout v-bind="{ title }">
            <order-list v-bind="{ type }">
                <template #status="{ loading }">
                    <purchase-status v-bind="{ type, loading }" />
                </template>
            </order-list>
        </mypage-layout>
    </client-page>
</template>

<script>
import { PURCHASE_TYPES } from "@/assets/variables";

import ClientPage from "@/components/client/templates/client-page.vue";
import OrderList from "@/components/client/mypage/order/order-list.vue";
import MypageLayout from "@/components/client/templates/mypage-layout.vue";
import PurchaseStatus from "@/components/client/mypage/purchase/purchase-status.vue";

export default {
    components: {
        ClientPage,
        OrderList,
        MypageLayout,
        PurchaseStatus,
    },
    props: {
        title: { type: String, default: "주문내역" },
        type: { type: String, default: JSON.stringify({ $ne: PURCHASE_TYPES.STOUT.value }) },
    },
};
</script>
